import React from "react";
import StepWizard from "react-step-wizard";
import NewOrder from "customer/orders/create-order/newOrder";
import ShippingDetails from "customer/orders/create-order/shippingDetails";
import FromDetails from "customer/orders/create-order/fromDetails";
import ToDetails from "customer/orders/create-order/toDetails";
import Destinations from "customer/orders/create-order/destinations";
import Summary from "customer/orders/create-order/summary";

function CreateOrder(props) {
  return (
    <StepWizard transitions={{}}>
      <NewOrder  />
      <ShippingDetails />
      <FromDetails />
      <ToDetails />
      <Destinations />
      <Summary />
    </StepWizard>
  );
}

export default CreateOrder;